export default __webpack_public_path__ + "static/media/a026-example3.4745b7eb.jpg";